import { isEqual } from 'lodash'

import { USER_NOTIFICATION_CONFIRMATION_TYPE, UserNotification } from '../schemas/schema'

const USER_NOTIFICATION_CHANNEL_PREFIX = 'personal:notifications'

export function getUserNotificationsChannel(id: string) {
  return `${USER_NOTIFICATION_CHANNEL_PREFIX}#${id}`
}

export function getUnreadNotifications(data: UserNotification[] = []) {
  const readNotifications = data.filter((notification) => notification.type === USER_NOTIFICATION_CONFIRMATION_TYPE)
  const restNotifications = data.filter((notification) => notification.type !== USER_NOTIFICATION_CONFIRMATION_TYPE)

  return restNotifications.filter(
    (notification) => !readNotifications.some((readNotification) => isEqual(readNotification.payload, notification)),
  )
}

export function getUserNotificationConfirmationMessage(notification: UserNotification) {
  return { type: USER_NOTIFICATION_CONFIRMATION_TYPE, payload: notification }
}
